module["exports"] = ["5##-###-###", "5##.###.###", "5## ### ###", "5########"];